import { useEtlLiveUpdates } from '@/viewmodel/features/etlSource/hooks/useEtlLiveUpdates';
import { useCurrentProjectIdViewModel } from '@/viewmodel/features/project';

export function useLiveUpdatesViewModel(): void {
  useEtlLiveUpdates(useCurrentProjectIdViewModel());
}
